import { render, staticRenderFns } from "./NusCodesPage.vue?vue&type=template&id=9c5c52ba&scoped=true&"
import script from "./NusCodesPage.vue?vue&type=script&lang=ts&"
export * from "./NusCodesPage.vue?vue&type=script&lang=ts&"
import style0 from "./NusCodesPage.vue?vue&type=style&index=0&id=9c5c52ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c5c52ba",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VTextField,VTooltip})
